import { Navigate, useLocation } from 'react-router';
import PageNotFound from '../common/lib/PageNotFound';
import type { MultiLang } from '../config';
import Functions from '../functions';

interface Props {
    lang: MultiLang;
    name: string;
}

const getRedirectUrl = (name: string, location: { pathname: string; search: string; hash: string }): string => {
    const pathname = location.pathname || '';
    const hash = location.hash || '';
    const query = new URLSearchParams(location.search);
    const search = new RegExp(`^/modules/${name}(?:/+(.*))?$`);
    const matches = pathname.match(search);
    if (matches === null) {
        return '';
    }
    const path = matches[1] || '';
    switch (path) {
        case '':
        case 'index.php': {
            const catId = query.get('cat_id');
            if (catId !== null && catId.match(/^\d+$/) !== null) {
                return `/${name}/category/${Functions.escape(catId)}`;
            }
            const forumId = query.get('forum_id');
            if (forumId !== null && forumId.match(/^\d+$/) !== null) {
                return `/${name}/forum/${Functions.escape(forumId)}`;
            }
            const topicId = query.get('topic_id');
            if (topicId !== null && topicId.match(/^\d+$/) !== null) {
                const postMatches = hash.match(/^#post_id(\d+)$/);
                return `/${name}/topic/${Functions.escape(topicId)}${postMatches === null ? '' : `#postId${postMatches[1]}`}`;
            }
            const postId = query.get('post_id');
            if (postId !== null && postId.match(/^\d+$/) !== null) {
                return `/${name}/post/${Functions.escape(postId)}`;
            }
            const catIds = query.get('cat_ids');
            if (catIds !== null && catIds.match(/^\d+$/) !== null) {
                return `/${name}/category/${Functions.escape(catIds)}`;
            }
            return `/${name}/`;
        }
    }
    return `/${name}/${path}`;
};

const D3ForumXoopsPathRedirect = (props: Props) => {
    const { lang, name } = props;
    const location = useLocation();
    const url = getRedirectUrl(name, location);
    if (url === '') {
        return <PageNotFound lang={lang} />;
    }
    return <Navigate to={url} replace />;
};

export default D3ForumXoopsPathRedirect;
